import NURL from '@naverpay/nurl'

import {BASE_PATH} from '$config'
import {INTERNAL_ROUTES} from '$constants/internal-routes'
import baseOrigin from '$utils/baseOrigin'
interface buildUrlProps {
    baseUrl?: string
    protocol?: string
    host?: string
    port?: string
    pathname?: string
    query?: object
    hash?: string
    withBasePath?: boolean
}

const normalizePathname = (pathname: string, withBasePath: boolean) => {
    const isInternalRoutes = Object.values(INTERNAL_ROUTES).includes(pathname)
    return withBasePath || isInternalRoutes ? `${BASE_PATH}${pathname}` : pathname
}

/**
 * @deprecated @naverpay/nurl 을 사용해주세요. 내부 구현도 이미 해당 패키지로 대체 되었습니다.
 */
const buildUrl = ({
    baseUrl = baseOrigin,
    protocol,
    host,
    port,
    pathname,
    query,
    hash,
    withBasePath = false,
}: buildUrlProps) => {
    const parsedQuery = query ? Object.fromEntries(new Map(Object.entries(query))) : undefined
    const url = new NURL({
        baseUrl,
        protocol,
        host,
        port,
        hash,
        ...(parsedQuery && {query: parsedQuery}),
        ...(pathname && {pathname: normalizePathname(pathname, withBasePath)}),
    })

    return url.toString()
}

export default buildUrl
